export type Translations = Record<string, Record<string, string>>;

const en = {
  'common.refresh': 'Refresh',
  'common.action': 'Action',
  'common.settings': 'Settings',
  sidebar_update: 'Refresh',
  sidebar_collapse: 'Collapse sidebar',
  sidebar_expand: 'Expand sidebar',

  'appMenu.appName': 'Task Management',
  'appConfig.layoutMenu': 'App layout settings',
  'appConfig.menuConfigMenu': 'App menu configuration',
  'appConfig.uploadConfigMenu': 'Upload configuration',
  'template.aside.menuTitle': 'Aside template example',
  'template.aside.pageTitle': 'Aside template page',
  'template.aside.pageDesc': 'Aside template description',
  'template.aside.refresh': 'Refresh',
  'template.aside.action': 'Action',
  'menuPage.title': 'App menu management',
  'menuPage.subtitle': 'Support CRUD and sync VS Code theme style',
  'menuPage.action.refresh': 'Refresh',
  'menuPage.action.create': 'New menu',
  'menuPage.action.edit': 'Edit',
  'menuPage.action.createChild': 'Sub menu',
  'menuPage.action.delete': 'Delete',
  'menuPage.confirm.delete': 'Delete this menu?',
  'menuPage.message.deleteSuccess': 'Deleted successfully',
  'menuPage.message.deleteFail': 'Delete failed',
  'menuPage.message.updateSuccess': 'Updated successfully',
  'menuPage.message.createSuccess': 'Created successfully',
  'menuPage.message.formInvalid': 'Please check form values',
  'menuPage.message.actionFailed': 'Operation failed',
  'menuPage.message.toggleSuccess': 'Visibility updated',
  'menuPage.message.toggleFail': 'Update failed',
  'menuPage.message.fetchFailed': 'Failed to load menu list',
  'menuPage.columns.name': 'Name',
  'menuPage.columns.path': 'Path',
  'menuPage.columns.type': 'Type',
  'menuPage.columns.parent': 'Parent',
  'menuPage.columns.order': 'Order',
  'menuPage.columns.visible': 'Visible',
  'menuPage.columns.actions': 'Actions',
  'menuPage.modal.createTitle': 'Create menu',
  'menuPage.modal.editTitle': 'Edit menu',
  'menuPage.form.name.label': 'Name',
  'menuPage.form.name.required': 'Please enter a name',
  'menuPage.form.name.placeholder': 'e.g. Dashboard',
  'menuPage.form.type.label': 'Menu type',
  'menuPage.form.parent.label': 'Parent menu',
  'menuPage.form.parent.placeholder': 'Select parent (optional)',
  'menuPage.form.route.label': 'Route path',
  'menuPage.form.route.placeholder': '/example/list',
  'menuPage.form.icon.label': 'Icon',
  'menuPage.form.icon.placeholder': 'e.g. HomeOutlined',
  'menuPage.form.i18nKey.label': 'I18n key',
  'menuPage.form.i18nKey.placeholder': 'e.g. menu.home',
  'menuPage.form.permission.label': 'Permission',
  'menuPage.form.permission.placeholder': 'e.g. menu:view',
  'menuPage.form.target.label': 'Open target',
  'menuPage.form.target.self': 'Current window',
  'menuPage.form.target.blank': 'New window',
  'menuPage.form.order.label': 'Order',
  'menuPage.form.hidden.label': 'Hidden',
  'menuPage.form.meta.label': 'Extra fields (JSON)',
  'menuPage.form.meta.placeholder': 'e.g. {"badge":"new"}',
  'menuPage.menuType.submenu': 'Menu (submenu)',
  'menuPage.menuType.group': 'Group',
  'menuPage.menuType.item': 'Item',
  'menuPage.menuType.divider': 'Divider',
  'uploadConfig.title': 'File Upload Settings',
  'uploadConfig.subtitle':
    'Configure S3 / OSS / COS direct upload for task attachments',
  'uploadConfig.form.activeProvider': 'Active Provider',
  'uploadConfig.form.maxFileSizeMB': 'Max file size (MB)',
  'uploadConfig.form.allowedMimeTypes': 'Allowed MIME types',
  'uploadConfig.message.loadFailed': 'Failed to load upload config',
  'uploadConfig.message.saveSuccess': 'Upload config saved',
  'uploadConfig.message.saveFailed': 'Failed to save upload config',
  'uploadConfig.message.formInvalid': 'Please check upload config form',
  'uploadConfig.message.invalidMaxSize': 'Max file size must be greater than 0',
  'example.placeholder': 'Example content',
  task_management: 'Task Management',
  // Dashboard translations
  // Today page translations
  task_today_title: 'Today',
  task_today_description: "Review and complete today's planned tasks",
  task_today_sort_tooltip: 'Sort',
  task_today_more_actions: 'More actions',
  task_today_menu_filter: 'Filter settings',
  task_today_menu_refresh: 'Refresh data',
  task_today_menu_export: 'Export tasks',
  task_today_stat_total: 'Total Tasks',
  task_today_stat_completed: 'Completed',
  task_today_stat_in_progress: 'In Progress',
  task_today_stat_completion_rate: 'Completion Rate',
  task_today_overdue_tag: 'Overdue Tasks',
  task_today_urgent_tag: 'Urgent Tasks',
  task_today_filter_title: 'Filter Settings',
  task_today_filter_status_label: 'Status Filter',
  task_today_filter_status_placeholder: 'Select status',
  task_today_filter_priority_label: 'Priority Filter',
  task_today_filter_priority_placeholder: 'Select priority',
  task_today_filter_task_list_label: 'Task List',
  task_today_filter_task_list_placeholder: 'Select task list',
  task_today_filter_date_label: 'Date Range',
  task_today_filter_date_placeholder: 'Select date',
  task_today_filter_stats_label: "Today's Summary",
  task_today_drawer_stat_total: 'Total Tasks',
  task_today_drawer_stat_completed: 'Completed',
  task_today_drawer_stat_overdue: 'Overdue Tasks',
  task_today_drawer_stat_urgent: 'Urgent Tasks',
  task_today_reset_filters: 'Clear All Filters',
  // Week page translations
  task_week_title: 'This Week',
  task_week_description:
    'View this week (Monday to Sunday) task schedule and completion status',
  task_week_menu_filter: 'Filter settings',
  task_week_menu_refresh: 'Refresh data',
  task_week_menu_export: 'Export tasks',
  task_week_stat_total: 'Total Tasks',
  task_week_stat_completed: 'Completed',
  task_week_stat_in_progress: 'In Progress',
  task_week_stat_completion_rate: 'Completion Rate',
  task_week_stat_urgent: 'Urgent Tasks',
  task_week_stat_overdue: 'Overdue Tasks',
  task_week_progress_label: 'Overall Completion Progress',
  task_week_filter_title: 'Filter Settings',
  task_week_filter_status_label: 'Status Filter',
  task_week_filter_status_placeholder: 'Select status',
  task_week_filter_priority_label: 'Priority Filter',
  task_week_filter_priority_placeholder: 'Select priority',
  task_week_filter_task_list_label: 'Task List',
  task_week_filter_task_list_placeholder: 'Select task list',
  task_week_filter_date_label: 'Date Range',
  task_week_filter_date_start_placeholder: 'Start date',
  task_week_filter_date_end_placeholder: 'End date',
  task_week_filter_stats_label: 'This Week Summary',
  task_week_drawer_stat_total: 'Total Tasks',
  task_week_drawer_stat_completed: 'Completed',
  task_week_drawer_stat_overdue: 'Overdue Tasks',
  task_week_drawer_stat_urgent: 'Urgent Tasks',
  task_week_daily_completion_label: 'Daily Completion Status This Week',
  task_week_reset_filters: 'Clear All Filters',
  task_week_sort_tooltip: 'Sort',
  task_week_more_actions: 'More options',
  // Next 7 Days page translations
  task_next7days_title: 'Next 7 Days',
  task_next7days_description:
    'View task schedule and completion status for the next 7 days starting from today',
  task_next7days_menu_filter: 'Filter settings',
  task_next7days_menu_refresh: 'Refresh data',
  task_next7days_menu_export: 'Export tasks',
  task_next7days_stat_total: 'Total Tasks',
  task_next7days_stat_completed: 'Completed',
  task_next7days_stat_in_progress: 'In Progress',
  task_next7days_stat_completion_rate: 'Completion Rate',
  task_next7days_stat_urgent: 'Urgent Tasks',
  task_next7days_stat_overdue: 'Overdue Tasks',
  task_next7days_progress_label: 'Overall Completion Progress',
  task_next7days_filter_title: 'Filter Settings',
  task_next7days_filter_status_label: 'Status Filter',
  task_next7days_filter_status_placeholder: 'Select status',
  task_next7days_filter_priority_label: 'Priority Filter',
  task_next7days_filter_priority_placeholder: 'Select priority',
  task_next7days_filter_task_list_label: 'Task List',
  task_next7days_filter_task_list_placeholder: 'Select task list',
  task_next7days_filter_date_label: 'Date Range',
  task_next7days_filter_date_start_placeholder: 'Start date',
  task_next7days_filter_date_end_placeholder: 'End date',
  task_next7days_filter_stats_label: 'Next 7 Days Summary',
  task_next7days_drawer_stat_total: 'Total Tasks',
  task_next7days_drawer_stat_completed: 'Completed',
  task_next7days_drawer_stat_overdue: 'Overdue Tasks',
  task_next7days_drawer_stat_urgent: 'Urgent Tasks',
  task_next7days_daily_completion_label: 'Daily Completion Status Next 7 Days',
  task_next7days_reset_filters: 'Clear All Filters',
  task_next7days_sort_tooltip: 'Sort',
  task_next7days_more_actions: 'More options',
  task_status_todo: 'Todo',
  task_status_in_progress: 'In Progress',
  task_status_unknown: 'Unknown',
  task_priority_none: 'None',
  task_priority_low: 'Low',
  task_priority_medium: 'Medium',
  task_priority_high: 'High',
  task_priority_urgent: 'Urgent',
  total: 'Total',
  in_progress: 'In Progress',
  blocked: 'Blocked',
  completed: 'Completed',
  needs_attention: 'Needs Attention',
  completion_rate: 'Completion Rate',
  total_tasks: 'Total Tasks',
  todo: 'Todo',
  review: 'Review',
  none: 'None',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  urgent: 'Urgent',
  recent_7_days_completion_trend: 'Recent 7 Days Completion Trend',
  priority_distribution: 'Priority Distribution',
  this_week_achievements: 'This Week Achievements',
  this_week_tasks: 'This Week Tasks',
  this_week_new: 'This Week New',
  this_week_task_trend: 'This Week Task Trend',
  new: 'New',
  status_distribution: 'Status Distribution',
  task_status_distribution: 'Task Status Distribution',
  task_priority_distribution: 'Task Priority Distribution',
  recent_7_days_completion_trend_chart: 'Recent 7 Days Completion Trend',
  task_creation_completion_comparison:
    'Task Creation and Completion Comparison (Last 30 Days)',
  create_task: 'Create Task',
  complete_task: 'Complete Task',
  upcoming_due: 'Upcoming Due',
  no_upcoming_tasks: 'No upcoming tasks',
  overdue: 'Overdue',
  great_no_overdue_tasks: 'Great! No overdue tasks',
  view_all: 'View All',
  my_workspace: 'My Workspace',
  quick_access_description:
    'Quick access to tasks you are responsible for, created, and watching',
  no_tasks: 'No tasks',
  more: 'More',
  task_filter_relations_label: 'Relation to me',
  task_filter_relations_placeholder: 'All three relations',
  assigned_to_me: 'Assigned to Me',
  task_assign_title: 'Assigned to Me',
  task_assign_description:
    'Manage all tasks assigned to you and track progress',
  tag_detail_title_fallback: 'Tag Detail',
  tag_detail_description: 'Manage tasks under this tag',
  created_by_me: 'Created by Me',
  watched_by_me: 'Watched by Me',
  board_quick_access: 'Board Quick Access',
  quick_jump_to_boards: 'Quick jump to your project boards',
  open_board: 'Open Board',
  no_data: 'No data',
  task_total: 'Task Total',
  day: 'Day',
  welcome_back: 'Welcome back',
  all_tasks: 'All Tasks',
  all_tasks_description:
    'View and manage all tasks you created or are responsible for, with multiple filtering and sorting options',
  overdue_tasks: 'Overdue Tasks',
  task_completion: 'Task Completion',
  task_status_distribution_title: 'Task Status Distribution',
  task_priority_distribution_title: 'Task Priority Distribution',
  recent_7_days_completion_trend_title: 'Recent 7 Days Completion Trend',
  upcoming_due_title: 'Upcoming Due',
  no_upcoming_tasks_message: 'No upcoming tasks',
  overdue_title: 'Overdue',
  great_no_overdue_tasks_message: 'Great! No overdue tasks',
  // Subtask translations
  subtask_list_empty: 'No subtasks',
  subtask_add: 'Add Subtask',
  subtask_title_placeholder: 'Enter subtask title',
  subtask_title_required: 'Please enter subtask title',
  subtask_add_success: 'Subtask added successfully',
  subtask_add_failed: 'Failed to add subtask, please try again',
  subtask_update_success: 'Subtask updated successfully',
  subtask_update_failed: 'Failed to update subtask, please try again',
  subtask_delete_success: 'Subtask deleted successfully',
  subtask_delete_failed: 'Failed to delete subtask, please try again',
  subtask_delete_confirm: 'Are you sure you want to delete this subtask?',
  subtask_completed: 'Subtask completed',
  subtask_uncompleted: 'Subtask uncompleted',
  subtask_status_update_failed:
    'Failed to update subtask status, please try again',
  confirm: 'Confirm',
  cancel: 'Cancel',
  common_all: 'All',
  task_search: 'Search Tasks',
  task_search_description: 'Use multiple conditions to quickly find tasks',
  task_search_placeholder: 'Search tasks...',
  task_search_scope_label: 'Search Scope',
  task_search_scope_my_tasks: 'My Related Tasks',
  task_search_scope_assigned: 'Assigned to Me',
  task_search_scope_created: 'Created by Me',
  task_search_scope_assigned_out: 'Assigned by Me',
  task_search_scope_watched: 'Watched by Me',
  task_search_sort_label: 'Sort By',
  task_search_sort_created_at: 'Created Time',
  task_search_sort_updated_at: 'Updated Time',
  task_search_sort_due_date: 'Due Date',
  task_search_sort_priority: 'Priority',
  task_search_order_label: 'Sort Order',
  task_search_advanced_filters: 'Advanced Filters',
  task_search_advanced_title: 'Advanced Search Filters',
  task_search_apply_filters: 'Apply',
  task_search_reset_filters: 'Reset Filters',
  task_search_date_range: 'Date Range',
  task_search_task_lists: 'Task Lists',
  task_search_tags: 'Tags',
  task_search_member_assignee: 'Assignee',
  task_search_member_creator: 'Creator',
  task_search_mobile_filters: 'Filters',
  task_only_my_tasks: 'Only My Tasks',
  task_only_my_tasks_hint:
    'Only show tasks I created, assigned to me, or I am watching',
  task_all_tasks_hint: 'Show all tasks in the organization',
  task_enabled: 'On',
  task_disabled: 'Off',
  task_filter_conditions: 'Filter Conditions',
  task_status_label: 'Status',
  task_priority_label: 'Priority',
  task_task_list: 'Task List',
  task_assignee: 'Assignee',
  task_select_assignee: 'Select Assignee',
  task_field_creator: 'Creator',
  task_start_time: 'Start Time',
  task_due_date: 'Due Date',
  task_sort_method: 'Sort Method',
  task_field_updated_at: 'Updated At',
  task_field_created_at: 'Created At',
  task_field_due_date: 'Due Date',
  task_field_priority: 'Priority',
  task_sort_descending: 'Descending',
  task_sort_ascending: 'Ascending',
  task_clear_filters: 'Clear Filters',
  task_message_no_data: 'No search results',
  // Task detail translations
  task_detail_select_task: 'Select a task to view details',
  task_detail_load_subtasks_failed: 'Failed to load subtasks, please try again',
  task_detail_load_task_lists_failed:
    'Failed to load task lists, please try again',
  task_detail_update_success: 'Updated successfully',
  task_detail_update_failed: 'Update failed, please try again',
  task_detail_add_description: 'Add task description',
  task_detail_description_placeholder:
    'Provide more details about this task...',
  task_detail_status_todo: 'Todo',
  task_detail_status_in_progress: 'In Progress',
  task_detail_status_blocked: 'Blocked',
  task_detail_status_review: 'In Review',
  task_detail_priority_none: 'None',
  task_detail_priority_low: 'Low',
  task_detail_priority_medium: 'Medium',
  task_detail_priority_high: 'High',
  task_detail_priority_urgent: 'Urgent',
  task_detail_progress_updated: 'Progress updated successfully',
  task_detail_assignee_updated: 'Assignee updated successfully',
  task_detail_assignee_update_failed:
    'Failed to update assignee, please try again',
  task_detail_watch_update_failed:
    'Failed to update watchers, please try again',
  task_detail_watch_update_success: 'Watchers updated successfully',
  task_detail_start_time_updated: 'Start time updated',
  task_detail_due_date_updated: 'Due date updated',
  common_yesterday: 'Yesterday',
  common_today: 'Today',
  common_tomorrow: 'Tomorrow',
  common_day_before_yesterday: 'Day before yesterday',
  common_day_after_tomorrow: 'Day after tomorrow',
  common_next_monday: 'Next Monday',
  common_seven_days_later: 'Seven days later',
  task_detail_start_time: 'Start Time',
  task_detail_due_date: 'Due Date',
  task_detail_overdue_days: 'Overdue Days',
  task_detail_status_label: 'Status',
  task_detail_priority_label: 'Priority',
  task_detail_assignee_label: 'Assignee',
  task_detail_creator_label: 'Creator',
  task_detail_progress_label: 'Progress',
  task_detail_schedule_label: 'Schedule',
  task_detail_additional_info_label: 'Additional Information',
  task_detail_task_lists_label: 'Task Lists',
  task_detail_task_lists_empty: 'Not added to any list',
  common_edit: 'Edit',
  common_save: 'Save',
  common_cancel: 'Cancel',
  common_create: 'Create',
  task_detail_tags_label: 'Tags',
  task_detail_tags_empty: 'No tags yet',
  task_detail_tags_updated: 'Tags updated successfully',
  task_detail_tags_update_failed: 'Failed to update tags, please try again',
  task_detail_watchers_label: 'Watchers',
  task_detail_attachments_label: 'Attachments',
  task_detail_unassigned: 'Unassigned',
  task_detail_unassigned_description:
    'Assign a responsible member to this task',
  task_detail_search_members_placeholder: 'Search members or enter email',
  common_loading: 'Loading...',
  common_select_placeholder: 'Please select',
  common_not_set: 'Not set',
  task_detail_subtasks_label: 'Subtasks',
  task_detail_subtasks_count_suffix: 'items',
  task_detail_add_watcher: 'Add watcher',
  task_detail_start_edit_title_tooltip: 'Click to edit title',
  task_detail_start_edit_content_tooltip: 'Click to edit content',
  task_detail_created_at: 'Created at',
  task_detail_updated_at: 'Updated at',
  task_detail_overdue_tag: 'Overdue',
  task_detail_watch_added: 'Watch relationship added',
  task_detail_watch_removed: 'Watch relationship removed',
  task_detail_select_task_lists_placeholder: 'Select task lists',
  task_detail_select_tags_placeholder: 'Select tags',
  task_detail_tag_navigation_hint: 'Use ↑ ↓ to move, Enter to select',
  task_detail_list_navigation_hint: 'Use ↑ ↓ to navigate lists',
  task_detail_watchers_count_suffix: 'people watching',
  task_detail_attachments_count_suffix: 'attachments',
  task_detail_attachment_size_unit: 'KB',
  task_detail_no_matching_members: 'No matching members',
  task_detail_status_updated: 'Status updated successfully',
  task_detail_priority_updated: 'Priority updated successfully',
  task_detail_watch_status_updated: 'Watch status updated successfully',
  task_detail_task_lists_updated: 'Task lists updated successfully',
  task_detail_task_lists_update_failed:
    'Failed to update task lists, please try again',
  task_detail_progress_update_failed:
    'Failed to update progress, please try again',
  task_list_quick_add_placeholder: 'Quick add task (Press Enter to create)',
  task_create_success: 'Task created successfully',
  task_list_pagination_total: 'Items {start}-{end} of {total}',
  task_list_select_task_hint: 'Select a task to view details',
  task_group_view_list: 'List',
  task_group_view_card: 'Card',
  task_group_view_relation: 'Relationships',
  task_group_none: 'No Grouping',
  task_group_task_list: 'Task List',
  task_group_tag: 'Tag',
  task_group_status: 'Status',
  task_group_priority: 'Priority',
  task_group_time: 'Time',
  task_group_repeat: 'Repeat',
  task_group_show_empty: 'Show Empty Groups',
  task_group_show_completed: 'Show Completed Tasks',
  task_group_show_overdue: 'Show Overdue Tasks',
  task_group_show_title: 'Show Group Titles',
  task_group_display: 'Group Display',
  task_group_move_up: 'Move Up',
  task_group_move_down: 'Move Down',
  task_group_title: 'Title',
  task_group_default_expanded: 'Expanded by Default',
  task_group_show_config: 'Display Settings',
  task_detail_start_time_set_yesterday: 'Start time set to yesterday',
  task_detail_start_time_set_today: 'Start time set to today',
  task_detail_start_time_set_tomorrow: 'Start time set to tomorrow',
  task_detail_start_time_set_day_after_tomorrow:
    'Start time set to the day after tomorrow',
  task_detail_start_time_set_next_monday: 'Start time set to next Monday',
  task_detail_start_time_set_seven_days_later:
    'Start time set to seven days later',
  task_detail_due_date_set_today: 'Due date set to today',
  task_detail_due_date_set_tomorrow: 'Due date set to tomorrow',
  task_detail_due_date_set_day_after_tomorrow:
    'Due date set to the day after tomorrow',
  task_detail_due_date_set_next_monday: 'Due date set to next Monday',
  task_detail_due_date_set_seven_days_later: 'Due date set to seven days later',
  task_detail_load_tags_failed: 'Failed to load tags, please try again',
  task_detail_default_list_tag: 'Default',
  task_detail_public_list_tag: 'Public',
  task_detail_unknown_user: 'Unknown user',
  task_detail_markdown_edit_tab: 'Edit',
  task_detail_markdown_preview_tab: 'Preview',
  task_detail_markdown_insert_image: 'Insert Image Markdown',
  task_detail_markdown_preview_empty: 'Nothing to preview',
  task_detail_upload_attachment: 'Upload file',
  task_detail_upload_success: 'Attachment uploaded',
  task_detail_upload_failed: 'Upload failed',
  task_detail_upload_config_missing: 'Upload config is incomplete',
  task_detail_upload_mime_not_allowed: 'File type is not allowed',
  task_detail_upload_file_too_large: 'File is too large',
  task_detail_attachment_download: 'Download',
  task_detail_attachment_download_failed: 'Failed to download attachment',
  task_detail_attachment_delete_confirm: 'Delete this attachment?',
  task_detail_attachment_delete_success: 'Attachment deleted',
  task_detail_attachment_delete_failed: 'Failed to delete attachment',
  // Task item translations
  task_item_completed: 'Task completed',
  task_item_reactivated: 'Task reactivated',
  task_item_delete_success: 'Task deleted',
  task_item_delete_failed: 'Failed to delete task',
  task_item_update_status_failed: 'Failed to update task status',
  task_item_title_empty: 'Title cannot be empty',
  task_item_title_update_success: 'Title updated successfully',
  task_item_title_update_failed: 'Failed to update title, please try again',
  task_item_delete_button: 'Delete task',
  task_item_no_tasks: 'No tasks',
  task_item_priority_none: 'None',
  task_item_priority_low: 'Low',
  task_item_priority_medium: 'Medium',
  task_item_priority_high: 'High',
  task_item_priority_urgent: 'Urgent',
  task_item_days_after: 'days later',
  task_item_due_short: 'Due',
  task_item_start_short: 'Start',
  task_item_no_due: 'No due date',
  // Task config translations
  task_config_assign_title: 'My Assigned Tasks',
  task_config_today_title: 'My Today Tasks',
  task_config_week_title: 'My This Week Tasks',
  task_config_next7days_title: 'My Next 7 Days Tasks',
  task_config_to_assign_title: 'Tasks I Assigned',
  task_config_completed_title: 'My Completed Tasks',
  task_config_all_title: 'My Tasks',
  task_config_create_title: 'Tasks I Created',
  task_config_board_title: 'Board Tasks',
  task_config_member_title: 'Member Tasks',
  task_config_task_list_title: 'Task List Tasks',
  task_config_tag_title: 'Tag Tasks',
  // Task create button translations
  task_create_button_new_task: 'New Task',
  ai_decompose_mode: 'AI Decompose',
  task_create_button_create_new_task: 'Create New Task',
  task_create_button_basic_info: 'Basic Information',
  task_create_button_task_properties: 'Task Properties',
  task_create_button_task_title: 'Task Title',
  task_create_button_priority: 'Priority',
  task_create_button_status: 'Status',
  task_create_button_assignee: 'Assignee',
  task_create_button_start_date: 'Start Date',
  task_create_button_due_date: 'Due Date',
  task_create_button_task_description: 'Task Description',
  task_create_button_task_lists: 'Task Lists',
  task_create_button_task_tags: 'Task Tags',
  task_create_button_create: 'Create',
  task_create_button_cancel: 'Cancel',
  task_create_button_low_priority: 'Low Priority',
  task_create_button_medium_priority: 'Medium Priority',
  task_create_button_high_priority: 'High Priority',
  task_create_button_urgent_priority: 'Urgent',
  task_create_button_todo: 'Todo',
  task_create_button_in_progress: 'In Progress',
  task_create_button_please_enter_title: 'Please enter task title',
  task_create_button_title_max_length:
    'Task title cannot exceed 100 characters',
  task_create_button_title_placeholder: 'Please enter task title',
  task_create_button_assignee_placeholder: 'Please select assignee',
  task_create_button_start_date_placeholder: 'Please select start date',
  task_create_button_due_date_placeholder: 'Please select due date',
  task_create_button_description_placeholder:
    'Please enter task description (optional)',
  task_create_button_task_list_placeholder: 'Please select task lists',
  task_create_button_task_list_label: 'Select Task Lists (optional)',
  task_create_button_select_tags_hint: 'Select tags for task',
  task_create_button_selected_tags: 'Selected:',
  task_create_button_new_tag: 'New',
  task_create_button_no_tags: 'No tags',
  task_create_button_loading: 'Loading...',
  task_create_button_no_task_lists: 'No task lists',
  task_create_button_create_success: 'Task created successfully',
  task_create_button_create_failed: 'Failed to create task, please try again',
  // Task template translations
  task_template_fix_bug: 'Fix Bug:',
  task_template_requirement_discussion: 'Requirement Discussion:',
  task_template_code_review: 'Code Review:',
  task_template_optimize_performance: 'Optimize Performance:',
  task_template_phenomenon: 'Phenomenon',
  task_template_phenomenon_text: 'Phenomenon:\n- ',
  task_template_expectation: 'Expectation',
  task_template_expectation_text: 'Expectation:\n- ',
  task_template_reproduction_steps: 'Reproduction Steps',
  task_template_reproduction_steps_text: 'Reproduction Steps:\n1. \n2. \n3. ',
  task_template_solution: 'Solution',
  task_template_solution_text:
    'Solution:\n- Approach:\n- Impact:\n- Risk & Rollback:',
  // Tag modal translations
  tag_modal_create_tag: 'Create Tag',
  tag_modal_edit_tag: 'Edit Tag',
  tag_modal_basic_info: 'Basic Information',
  tag_modal_tag_icon: 'Tag Icon',
  tag_modal_tag_color: 'Tag Color',
  tag_modal_tag_name: 'Tag Name',
  tag_modal_tag_description: 'Tag Description',
  tag_modal_name_required: 'Please enter tag name',
  tag_modal_name_max_length: 'Tag path cannot exceed 100 characters',
  tag_modal_description_max_length:
    'Tag description cannot exceed 100 characters',
  tag_modal_name_placeholder: 'Please enter tag name',
  tag_modal_description_placeholder: 'Please enter tag description (optional)',
  tag_modal_create_success: 'Tag created successfully',
  tag_modal_update_success: 'Tag updated successfully',
  tag_modal_create_failed: 'Failed to create tag',
  tag_modal_update_failed: 'Failed to update tag',
  tag_modal_cancel: 'Cancel',
  tag_modal_update_tag: 'Update Tag',
  tag_modal_id_missing: 'Tag ID is missing',
  tag_modal_public_tag: 'Public Tag',
  tag_modal_shared_members_help: 'Private tags can be shared with members.',
  tag_modal_shared_members_placeholder:
    'Select members to share with (optional)',
  resource_shared_members: 'Shared Members',
  // Board translations
  board_title: 'Task Board',
  board_description:
    'Manage and organize your task boards to improve team collaboration efficiency',
  board_create: 'Create Board',
  board_create_first: 'Create Your First Board',
  board_name: 'Board Name',
  board_description_label: 'Board Description',
  board_name_placeholder: 'Please enter board name',
  board_description_placeholder: 'Please enter board description (optional)',
  board_name_required: 'Please enter board name',
  board_create_success: 'Board created successfully',
  board_create_failed: 'Failed to create board',
  board_update_success: 'Board updated successfully',
  board_update_failed: 'Failed to update board',
  board_delete_success: 'Board deleted successfully',
  board_delete_failed: 'Failed to delete board',
  board_delete_confirm_title: 'Confirm Delete',
  board_delete_confirm_content:
    'Are you sure you want to delete board "{name}"?',
  board_copy_success: 'Board copied successfully',
  board_copy_failed: 'Failed to copy board',
  board_copy_suffix: ' - Copy',
  board_table_name: 'Board Name',
  board_table_description: 'Description',
  board_table_task_count: 'Task Count',
  board_table_is_public: 'Is Public',
  board_table_public: 'Public',
  board_table_private: 'Private',
  board_members_label: 'Invite enterprise members',
  board_members_help:
    'Private board members can be assigned a collaboration role.',
  board_members_placeholder: 'Select enterprise members',
  board_members_empty: 'No members invited',
  board_role_viewer: 'Viewer',
  board_role_editor: 'Editor',
  board_role_admin: 'Administrator',
  board_public_clears_members:
    'Making this board public will remove all invited members.',
  board_table_created_at: 'Created At',
  board_table_updated_at: 'Updated At',
  board_table_actions: 'Actions',
  board_table_view: 'View',
  board_table_edit: 'Edit',
  board_table_copy: 'Copy',
  board_table_delete: 'Delete',
  board_table_default: 'Default',
  board_table_empty: 'No boards yet, start creating your first board',
  board_table_pagination_total: 'Total {total} boards',
  board_edit_title: 'Edit Board',
  board_load_failed: 'Failed to load data',
  board_panel_personal: 'Personal Board',
  board_panel_personal_desc: 'View all tasks assigned to yourself',
  board_panel_member: 'Member Board',
  board_panel_member_desc: 'View tasks for specific members',
  board_panel_list: 'List Board',
  board_panel_list_desc: 'Organize and view tasks by task list',
  board_panel_tag: 'Tag Board',
  board_panel_tag_desc: 'View tasks by tag category',
  board_panel_create_success: 'Panel created successfully',
  board_panel_create_failed: 'Failed to create panel',
  board_panel_delete_success: 'Panel deleted successfully',
  board_panel_delete_failed: 'Failed to delete panel',
  board_panel_update_success: 'Panel updated successfully',
  board_panel_update_failed: 'Failed to update panel',
  board_panel_delete_confirm_content:
    'Are you sure you want to delete panel "{title}"?',
  board_manage_title: 'Manage Panels',
  board_manage_drag_hint: 'Drag to reorder panels',
  board_manage_move_top: 'Move to top',
  board_manage_move_up: 'Move up',
  board_manage_move_down: 'Move down',
  board_manage_move_bottom: 'Move to bottom',
  board_manage_delete_tooltip: 'Remove panel',
  board_manage_delete_confirm_title: 'Remove Panel',
  board_manage_delete_confirm_content: 'Remove panel "{title}" from the board?',
  board_manage_delete_also_list: 'Also delete the associated task list',
  board_manage_delete_also_list_warning:
    'The task list and all its tasks will be permanently deleted and cannot be recovered.',
  board_manage_empty: 'No panels to manage',
  board_manage_save_order_failed: 'Failed to save panel order',
  board_panel_select_member: 'Select Member',
  board_panel_select_list: 'Select Task List',
  board_panel_select_tag: 'Select Tag',
  board_panel_member_label: 'Member',
  board_panel_list_label: 'Task List',
  board_panel_tag_label: 'Tag',
  board_panel_unfinished_tasks: 'Unfinished',
  board_panel_completed_tasks: 'Completed',
  board_detail_title: 'Board Details',
  board_detail_description: 'Manage and organize your task panels',
  board_detail_not_found: 'Board does not exist',
  board_detail_name_required: 'Please enter board name',
  board_detail_type_required: 'Please select board type',
  board_detail_name_placeholder: 'Please enter board name',
  board_detail_description_placeholder:
    'Please enter board description (optional)',
  board_detail_load_failed: 'Failed to load data',
  board_detail_panel_name_label: 'Panel Name',
  board_detail_panel_description_label: 'Panel Description',
  board_detail_panel_type_label: 'Panel Type',
  board_detail_select_panel_type: 'Select panel type',
  board_detail_create_panel: 'Create Panel',
  board_detail_panel_total: '{count} panels',
  board_detail_create_first_panel: 'Create First Panel',
  board_detail_edit_panel: 'Edit Panel',
  board_detail_no_panels: 'No panels yet, start creating your first panel',
  board_detail_public_badge: 'Public',
  board_detail_unknown_member: 'Unknown member',
  board_detail_unknown_list: 'Unknown list',
  board_detail_unknown_tag: 'Unknown tag',
  board_detail_self: 'Self',
  board_detail_all_tasks: 'All Tasks',
  board_detail_completed: 'Completed',
  board_detail_in_progress: 'In Progress',
  board_detail_expected_tasks: 'Expected Tasks',
  board_detail_recent_tasks: 'Recent Tasks',
  board_detail_edit: 'Edit',
  board_detail_copy: 'Copy',
  board_detail_delete: 'Delete',
  board_detail_delete_confirm_title: 'Confirm Delete',
  // Task list translations
  task_list_delete_confirm_title: 'Confirm Delete',
  task_list_delete_confirm_content:
    'Are you sure you want to delete task list "{name}"? This action cannot be undone.',
  task_list_field_name: 'Task List Name',
  task_list_field_type: 'Type',
  task_list_type_static: 'Static',
  task_list_type_dynamic: 'Dynamic',
  task_list_field_status: 'Status',
  task_list_default: 'Default',
  task_list_public: 'Public',
  task_list_private: 'Private',
  task_list_field_creator: 'Creator',
  task_list_field_created_at: 'Created At',
  task_list_share: 'Share',
  task_list_rename: 'Rename',
  task_list_archive: 'Archive',
  task_task_lists: 'Task Lists',
  task_task_lists_description:
    'Manage task lists, organize and manage different types of task collections',
  task_list_create_new: 'Create New List',
  task_list_no_task_lists: 'No task lists yet',
  task_list_edit: 'Edit Task List',
  task_list_name: 'Task List Name',
  task_list_name_required: 'Please enter task list name',
  task_list_name_placeholder: 'Please enter task list name',
  task_list_description: 'Description',
  task_list_description_placeholder: 'Please enter description',
  task_list_type: 'Task List Type',
  task_list_type_placeholder: 'Select type',
  task_list_icon: 'Icon',
  task_list_color: 'Color',
  task_list_is_default: 'Default List',
  task_list_is_public: 'Public List',
  task_list_is_archived: 'Archived List',
  task_list_sort_weight: 'Sort Weight',
  task_list_advanced_settings: 'Advanced Settings',
  task_list_shared_members_help: 'Private lists can be shared with members.',
  task_list_shared_members_placeholder:
    'Select members to share with (optional)',
  task_list_create_success: 'Task list created successfully',
  task_list_create_error: 'Failed to create task list, please try again',
  task_list_share_success: 'Share settings saved',
  task_list_share_error: 'Failed to save share settings',
  task_list_share_title: 'Share Task List',
  task_list_share_description: 'Select members to share this task list with',
  task_list_share_tip: 'Click the X on selected member tags to unshare',
  task_list_allow_view: 'Allow View',
  task_list_allow_edit: 'Allow Edit',
  task_list_allow_delete: 'Allow Delete',
  task_list_notify_members: 'Notify Members',
  task_list_select_members: 'Select Members',
  task_list_search_members: 'Search members...',
  task_list_selected_members: 'Selected Members',
  task_list_no_members: 'No available members',
  task_list_no_members_found: 'No members found',
  // Activity translations
  task_activities_load_failed: 'Failed to load task activities',
  task_activity_created: 'Created',
  task_activity_updated: 'Updated',
  task_activity_completed: 'Completed',
  task_activity_assigned: 'Assigned',
  task_activity_commented: 'Commented',
  task_activity_status_changed: 'Status Changed',
  task_activity_priority_changed: 'Priority Changed',
  task_activity_watched: 'Watched',
  task_activity_unwatched: 'Unwatched',
  task_activity_merged: 'Merged',
  task_activities: 'Task Activities',
  task_activities_description: 'View the latest task activity updates',
  task_filter_by_activity_type: 'Filter by activity type',
  task_activities_count: 'activities',
  task_no_activities: 'No task activities yet',
  task_view_task: 'View Details',
  task_task_detail: 'Task Details',
  // Common translations
  common_just_now: 'Just now',
  common_minutes_ago: 'minutes ago',
  common_hours_ago: 'hours ago',
  common_days_ago: 'days ago',
  common_weeks_ago: 'weeks ago',
  common_total: 'Total',
  common_unknown: 'Unknown',
  common_actions: 'Actions',
  common_view: 'View',
  common_delete: 'Delete',
  common_refresh: 'Refresh',
  common_update: 'Update',
  common_pagination_total: 'Items {start}-{end} of {total}',
  // Other task translations
  task_completed: 'Completed',
  task_completed_description:
    'View all tasks you have completed, track completion history and achievements',
  task_assigned_out: 'Tasks I Assigned',
  task_assigned_out_description: 'View and manage tasks I assigned to others',
  task_my_created: 'Tasks I Created',
  task_my_created_description:
    'Manage all tasks you created, track progress and completion',
  task_my_watched: 'Tasks I Watch',
  task_my_watched_description: 'View and manage tasks I am watching',
  task_filter: 'Filter',
  task_sort: 'Sort',
  // Menu translations
  menu_dashboard: 'Dashboard',
  menu_assigned_to_me: 'Assigned to Me',
  menu_today: 'Today',
  menu_week: 'This Week',
  menu_next_7_days: 'Next 7 Days',
  menu_management: 'Management',
  menu_all_tasks: 'All Tasks',
  menu_my_created: 'Tasks I Created',
  menu_my_assigned: 'Tasks I Assigned',
  menu_my_watched: 'Tasks I Watch',
  menu_completed: 'Completed',
  menu_recycle_bin: 'Recycle Bin',
  menu_search: 'Search',
  menu_activities: 'Activities',
  menu_report: 'Task Report',
  menu_screen: 'Screen',
  menu_all_screens: 'All Screens',
  menu_visible_screens: 'Visible Screens',
  menu_public_screens: 'Public Screens',
  menu_private_screens: 'Private Screens',
  menu_task_lists: 'Task Lists',
  menu_all_task_lists: 'All Task Lists',
  menu_visible_task_lists: 'Visible Task Lists',
  menu_tags: 'Tags',
  menu_all_tags: 'All Tags',
  menu_visible_tags: 'Visible Tags',
  // Tag translations
  task_tags: 'Tags',
  task_tags_description: 'Manage all task tags and categories',
  task_start_date: 'Start Date',
  task_end_date: 'End Date',
  // Report translations
  report_task_category_design: 'Product Design',
  report_task_category_development: 'Development',
  report_task_category_testing: 'Testing',
  report_task_category_meeting: 'Meeting',
  report_today_title: 'Today Report',
  report_yesterday_title: 'Yesterday Report',
  report_day_before_yesterday_title: 'Day Before Yesterday Report',
  report_save_success: 'Report saved successfully',
  report_save_to_local: 'Report saved to local storage',
  report_create_success: 'Report created successfully',
  report_create_to_local: 'Report created and saved to local storage',
  report_select_date_placeholder: 'Please select date',
  report_today_work_placeholder: "Please enter today's completed work...",
  report_problems_placeholder: 'Please enter problems encountered...',
  report_tomorrow_plan_placeholder: "Please enter tomorrow's plan...",
  report_daily_summary_placeholder: 'Please enter daily work summary...',
  report_solution_placeholder: 'Please enter solution or approach...',
  report_reflection_placeholder: 'Please enter work reflection...',
  report_progress_placeholder: 'Please enter specific progress...',
  // Task list detail translations
  task_list_detail_load_failed: 'Failed to load task list details',
  task_list_detail_update_success: 'Task list updated successfully',
  task_list_detail_update_failed: 'Failed to update task list',
  task_list_detail_delete_success: 'Task list deleted successfully',
  task_list_detail_delete_failed: 'Failed to delete task list',
  task_list_detail_get_task_failed: 'Failed to get task',
  task_list_detail_task_already_in_list: 'Task is already in the current list',
  task_list_detail_task_added_success: 'Task added to list successfully',
  task_list_detail_add_task_failed: 'Failed to add task to list',
  task_list_detail_edit_list: 'Edit List',
  task_list_detail_refresh_data: 'Refresh Data',
  task_list_detail_delete_list: 'Delete List',
  task_list_detail_no_description: 'No description',
  task_list_detail_static_list: 'Static List',
  task_list_detail_dynamic_list: 'Dynamic List',
  task_list_detail_sort: 'Sort',
  task_list_detail_more_options: 'More Options',
  task_list_detail_search_task_placeholder:
    'Search and select tasks to add to list',
  task_list_detail_no_matching_tasks: 'No matching tasks found',
  task_list_detail_no_available_tasks: 'No available tasks',
  task_list_detail_unnamed_task: 'Unnamed Task',
} as const;

const zhCN = {
  'common.refresh': '刷新',
  'common.action': '操作',
  'common.settings': '设置',
  sidebar_update: '更新',
  sidebar_collapse: '折叠侧边栏',
  sidebar_expand: '展开侧边栏',

  'appMenu.appName': '任务管理',
  'appConfig.layoutMenu': '应用布局设置页面',
  'appConfig.menuConfigMenu': '应用菜单配置页面',
  'appConfig.uploadConfigMenu': '上传配置',
  'template.aside.menuTitle': '侧边示例模版',
  'template.aside.pageTitle': '侧边模版页面',
  'template.aside.pageDesc': '侧边模版描述',
  'template.aside.refresh': '刷新',
  'template.aside.action': '操作',
  'menuPage.title': '应用菜单管理',
  'menuPage.subtitle': '支持菜单增删改查，实时同步 VS Code 主题样式',
  'menuPage.action.refresh': '刷新',
  'menuPage.action.create': '新增菜单',
  'menuPage.action.edit': '编辑',
  'menuPage.action.createChild': '子菜单',
  'menuPage.action.delete': '删除',
  'menuPage.confirm.delete': '确认删除该菜单？',
  'menuPage.message.deleteSuccess': '删除成功',
  'menuPage.message.deleteFail': '删除失败',
  'menuPage.message.updateSuccess': '更新成功',
  'menuPage.message.createSuccess': '创建成功',
  'menuPage.message.formInvalid': '请检查表单填写',
  'menuPage.message.actionFailed': '操作失败',
  'menuPage.message.toggleSuccess': '已更新显示状态',
  'menuPage.message.toggleFail': '更新失败',
  'menuPage.message.fetchFailed': '获取菜单列表失败',
  'menuPage.columns.name': '名称',
  'menuPage.columns.path': '路径',
  'menuPage.columns.type': '类型',
  'menuPage.columns.parent': '父级',
  'menuPage.columns.order': '排序',
  'menuPage.columns.visible': '显示',
  'menuPage.columns.actions': '操作',
  'menuPage.modal.createTitle': '新增菜单',
  'menuPage.modal.editTitle': '编辑菜单',
  'menuPage.form.name.label': '名称',
  'menuPage.form.name.required': '请输入名称',
  'menuPage.form.name.placeholder': '如：工作台',
  'menuPage.form.type.label': '菜单类型',
  'menuPage.form.parent.label': '父级菜单',
  'menuPage.form.parent.placeholder': '选择父级（可选）',
  'menuPage.form.route.label': '路由路径',
  'menuPage.form.route.placeholder': '/example/list',
  'menuPage.form.icon.label': '图标',
  'menuPage.form.icon.placeholder': '如：HomeOutlined',
  'menuPage.form.i18nKey.label': '多语言 Key',
  'menuPage.form.i18nKey.placeholder': '如：menu.home',
  'menuPage.form.permission.label': '权限标识',
  'menuPage.form.permission.placeholder': '如：menu:view',
  'menuPage.form.target.label': '打开方式',
  'menuPage.form.target.self': '当前窗口',
  'menuPage.form.target.blank': '新窗口',
  'menuPage.form.order.label': '排序号',
  'menuPage.form.hidden.label': '隐藏',
  'menuPage.form.meta.label': '扩展字段 (JSON)',
  'menuPage.form.meta.placeholder': '例如：{"badge":"new"}',
  'menuPage.menuType.submenu': '菜单项 (submenu)',
  'menuPage.menuType.group': '分组菜单 (group)',
  'menuPage.menuType.item': '子菜单 (item)',
  'menuPage.menuType.divider': '分割线 (divider)',
  'uploadConfig.title': '文件上传配置',
  'uploadConfig.subtitle': '配置任务附件直传（S3 / OSS / COS）',
  'uploadConfig.form.activeProvider': '当前生效服务商',
  'uploadConfig.form.maxFileSizeMB': '最大文件大小 (MB)',
  'uploadConfig.form.allowedMimeTypes': '允许的 MIME 类型',
  'uploadConfig.message.loadFailed': '加载上传配置失败',
  'uploadConfig.message.saveSuccess': '上传配置已保存',
  'uploadConfig.message.saveFailed': '保存上传配置失败',
  'uploadConfig.message.formInvalid': '请检查上传配置表单',
  'uploadConfig.message.invalidMaxSize': '最大文件大小必须大于 0',
  'example.placeholder': '示例页面内容',
  task_management: '任务管理',
  // Dashboard translations
  // Today page translations
  task_today_title: '今天',
  task_today_description: '查看和完成今日计划的任务',
  task_today_sort_tooltip: '排序',
  task_today_more_actions: '更多操作',
  task_today_menu_filter: '筛选设置',
  task_today_menu_refresh: '刷新数据',
  task_today_menu_export: '导出任务',
  task_today_stat_total: '总任务',
  task_today_stat_completed: '已完成',
  task_today_stat_in_progress: '进行中',
  task_today_stat_completion_rate: '完成率',
  task_today_overdue_tag: '逾期任务',
  task_today_urgent_tag: '紧急任务',
  task_today_filter_title: '筛选设置',
  task_today_filter_status_label: '状态筛选',
  task_today_filter_status_placeholder: '选择状态',
  task_today_filter_priority_label: '优先级筛选',
  task_today_filter_priority_placeholder: '选择优先级',
  task_today_filter_task_list_label: '任务清单',
  task_today_filter_task_list_placeholder: '选择任务清单',
  task_today_filter_date_label: '日期范围',
  task_today_filter_date_placeholder: '选择日期',
  task_today_filter_stats_label: '今日统计',
  task_today_drawer_stat_total: '总任务数',
  task_today_drawer_stat_completed: '已完成',
  task_today_drawer_stat_overdue: '逾期任务',
  task_today_drawer_stat_urgent: '紧急任务',
  task_today_reset_filters: '清除所有筛选',
  // Week page translations
  task_week_title: '本周',
  task_week_description: '查看本周（周一到周日）的任务安排和完成情况',
  task_week_menu_filter: '筛选设置',
  task_week_menu_refresh: '刷新数据',
  task_week_menu_export: '导出任务',
  task_week_stat_total: '总任务',
  task_week_stat_completed: '已完成',
  task_week_stat_in_progress: '进行中',
  task_week_stat_completion_rate: '完成率',
  task_week_stat_urgent: '紧急任务',
  task_week_stat_overdue: '逾期任务',
  task_week_progress_label: '整体完成进度',
  task_week_filter_title: '筛选设置',
  task_week_filter_status_label: '状态筛选',
  task_week_filter_status_placeholder: '选择状态',
  task_week_filter_priority_label: '优先级筛选',
  task_week_filter_priority_placeholder: '选择优先级',
  task_week_filter_task_list_label: '任务清单',
  task_week_filter_task_list_placeholder: '选择任务清单',
  task_week_filter_date_label: '日期范围',
  task_week_filter_date_start_placeholder: '开始日期',
  task_week_filter_date_end_placeholder: '结束日期',
  task_week_filter_stats_label: '本周统计',
  task_week_drawer_stat_total: '总任务数',
  task_week_drawer_stat_completed: '已完成',
  task_week_drawer_stat_overdue: '逾期任务',
  task_week_drawer_stat_urgent: '紧急任务',
  task_week_daily_completion_label: '本周每日完成情况',
  task_week_reset_filters: '清除所有筛选',
  task_week_sort_tooltip: '排序',
  task_week_more_actions: '更多选项',
  // Next 7 Days page translations
  task_next7days_title: '未来7天',
  task_next7days_description: '查看从今天开始的未来7天任务安排和完成情况',
  task_next7days_menu_filter: '筛选设置',
  task_next7days_menu_refresh: '刷新数据',
  task_next7days_menu_export: '导出任务',
  task_next7days_stat_total: '总任务',
  task_next7days_stat_completed: '已完成',
  task_next7days_stat_in_progress: '进行中',
  task_next7days_stat_completion_rate: '完成率',
  task_next7days_stat_urgent: '紧急任务',
  task_next7days_stat_overdue: '逾期任务',
  task_next7days_progress_label: '整体完成进度',
  task_next7days_filter_title: '筛选设置',
  task_next7days_filter_status_label: '状态筛选',
  task_next7days_filter_status_placeholder: '选择状态',
  task_next7days_filter_priority_label: '优先级筛选',
  task_next7days_filter_priority_placeholder: '选择优先级',
  task_next7days_filter_task_list_label: '任务清单',
  task_next7days_filter_task_list_placeholder: '选择任务清单',
  task_next7days_filter_date_label: '日期范围',
  task_next7days_filter_date_start_placeholder: '开始日期',
  task_next7days_filter_date_end_placeholder: '结束日期',
  task_next7days_filter_stats_label: '未来7天统计',
  task_next7days_drawer_stat_total: '总任务数',
  task_next7days_drawer_stat_completed: '已完成',
  task_next7days_drawer_stat_overdue: '逾期任务',
  task_next7days_drawer_stat_urgent: '紧急任务',
  task_next7days_daily_completion_label: '未来7天每日完成情况',
  task_next7days_reset_filters: '清除所有筛选',
  task_next7days_sort_tooltip: '排序',
  task_next7days_more_actions: '更多选项',
  task_status_todo: '待办',
  task_status_in_progress: '进行中',
  task_status_unknown: '未知',
  task_priority_none: '无',
  task_priority_low: '低',
  task_priority_medium: '中',
  task_priority_high: '高',
  task_priority_urgent: '紧急',
  total: '总计',
  in_progress: '进行中',
  blocked: '阻塞中',
  completed: '已完成',
  needs_attention: '需关注',
  completion_rate: '完成率',
  total_tasks: '总数',
  todo: '待办',
  review: '审核中',
  none: '无',
  low: '低',
  medium: '中',
  high: '高',
  urgent: '紧急',
  recent_7_days_completion_trend: '最近7天完成率趋势',
  priority_distribution: '优先级分布',
  this_week_achievements: '本周成就',
  this_week_tasks: '本周任务',
  this_week_new: '本周新增',
  this_week_task_trend: '本周任务趋势',
  new: '新增',
  status_distribution: '状态分布',
  task_status_distribution: '任务状态分布',
  task_priority_distribution: '任务优先级分布',
  recent_7_days_completion_trend_chart: '最近7天完成趋势',
  task_creation_completion_comparison: '任务创建与完成对比（最近30天）',
  create_task: '创建任务',
  complete_task: '完成任务',
  upcoming_due: '即将到期',
  no_upcoming_tasks: '暂无即将到期的任务',
  overdue: '已逾期',
  great_no_overdue_tasks: '太棒了！没有逾期任务',
  view_all: '查看全部',
  my_workspace: '我的工作区',
  quick_access_description: '快速访问您负责、创建和关注的任务',
  no_tasks: '暂无任务',
  more: '更多',
  task_filter_relations_label: '与我的关系',
  task_filter_relations_placeholder: '全部三类关系',
  assigned_to_me: '我负责的',
  task_assign_title: '我负责的',
  task_assign_description: '管理您负责的所有任务，跟踪进度和完成情况',
  tag_detail_title_fallback: '标签详情',
  tag_detail_description: '管理该标签下的任务',
  created_by_me: '我创建的',
  watched_by_me: '我关注的',
  board_quick_access: '看板快速访问',
  quick_jump_to_boards: '快速跳转到您的项目看板',
  open_board: '打开看板',
  no_data: '暂无数据',
  task_total: '任务总数',
  day: '天',
  welcome_back: '欢迎回来',
  all_tasks: '全部任务',
  all_tasks_description:
    '查看和管理您创建或负责的所有任务，支持多种筛选和排序方式',
  overdue_tasks: '逾期任务',
  task_completion: '任务完成度',
  task_status_distribution_title: '任务状态分布',
  task_priority_distribution_title: '任务优先级分布',
  recent_7_days_completion_trend_title: '最近7天完成趋势',
  upcoming_due_title: '即将到期',
  no_upcoming_tasks_message: '暂无即将到期的任务',
  overdue_title: '已逾期',
  great_no_overdue_tasks_message: '太棒了！没有逾期任务',
  // Subtask translations
  subtask_list_empty: '暂无子任务',
  subtask_add: '添加子任务',
  subtask_title_placeholder: '输入子任务标题',
  subtask_title_required: '请输入子任务标题',
  subtask_add_success: '子任务添加成功',
  subtask_add_failed: '添加子任务失败，请重试',
  subtask_update_success: '子任务更新成功',
  subtask_update_failed: '更新子任务失败，请重试',
  subtask_delete_success: '子任务删除成功',
  subtask_delete_failed: '删除子任务失败，请重试',
  subtask_delete_confirm: '确定要删除这个子任务吗？',
  subtask_completed: '子任务已完成',
  subtask_uncompleted: '子任务已取消完成',
  subtask_status_update_failed: '更新子任务状态失败，请重试',
  confirm: '确定',
  cancel: '取消',
  common_all: '全部',
  task_search: '搜索任务',
  task_search_description: '使用多种条件快速查找任务',
  task_search_placeholder: '搜索任务...',
  task_search_scope_label: '搜索范围',
  task_search_scope_my_tasks: '我相关的任务',
  task_search_scope_assigned: '我负责的',
  task_search_scope_created: '我创建的',
  task_search_scope_assigned_out: '我指派的',
  task_search_scope_watched: '我关注的',
  task_search_sort_label: '排序字段',
  task_search_sort_created_at: '创建时间',
  task_search_sort_updated_at: '更新时间',
  task_search_sort_due_date: '截止日期',
  task_search_sort_priority: '优先级',
  task_search_order_label: '排序方向',
  task_search_advanced_filters: '高级筛选',
  task_search_advanced_title: '高级搜索筛选',
  task_search_apply_filters: '应用筛选',
  task_search_reset_filters: '重置筛选',
  task_search_date_range: '日期范围',
  task_search_task_lists: '任务清单',
  task_search_tags: '标签',
  task_search_member_assignee: '负责人',
  task_search_member_creator: '创建者',
  task_search_mobile_filters: '筛选',
  task_only_my_tasks: '只看我的任务',
  task_only_my_tasks_hint: '仅显示我创建、分配给我或我关注的任务',
  task_all_tasks_hint: '显示组织内所有任务',
  task_enabled: '开',
  task_disabled: '关',
  task_filter_conditions: '筛选条件',
  task_status_label: '状态',
  task_priority_label: '优先级',
  task_task_list: '任务清单',
  task_assignee: '负责人',
  task_select_assignee: '选择负责人',
  task_field_creator: '创建者',
  task_start_time: '开始时间',
  task_due_date: '截止时间',
  task_sort_method: '排序方式',
  task_field_updated_at: '更新时间',
  task_field_created_at: '创建时间',
  task_field_due_date: '截止日期',
  task_field_priority: '优先级',
  task_sort_descending: '降序',
  task_sort_ascending: '升序',
  task_clear_filters: '清除筛选',
  task_message_no_data: '暂无搜索结果',
  // Task detail translations
  task_detail_select_task: '选择一个任务查看详情',
  task_detail_load_subtasks_failed: '加载子任务失败，请重试',
  task_detail_load_task_lists_failed: '加载任务清单失败，请重试',
  task_detail_update_success: '更新成功',
  task_detail_update_failed: '更新失败，请重试',
  task_detail_add_description: '添加任务描述',
  task_detail_description_placeholder: '补充一些关于任务的详细信息...',
  task_detail_status_todo: '待办',
  task_detail_status_in_progress: '进行中',
  task_detail_status_blocked: '阻塞中',
  task_detail_status_review: '审核中',
  task_detail_priority_none: '无优先级',
  task_detail_priority_low: '低优先级',
  task_detail_priority_medium: '中优先级',
  task_detail_priority_high: '高优先级',
  task_detail_priority_urgent: '紧急优先级',
  task_detail_progress_updated: '进度更新成功',
  task_detail_assignee_updated: '负责人更新成功',
  task_detail_assignee_update_failed: '更新负责人失败，请重试',
  task_detail_watch_update_failed: '更新关注人失败，请重试',
  task_detail_watch_update_success: '关注人更新成功',
  task_detail_start_time_updated: '开始时间已更新',
  task_detail_due_date_updated: '截止日期已更新',
  common_yesterday: '昨天',
  common_today: '今天',
  common_tomorrow: '明天',
  common_day_before_yesterday: '前天',
  common_day_after_tomorrow: '后天',
  common_next_monday: '下周一',
  common_seven_days_later: '七天后',
  task_detail_start_time: '开始时间',
  task_detail_due_date: '截止日期',
  task_detail_overdue_days: '逾期天数',
  task_detail_status_label: '任务状态',
  task_detail_priority_label: '优先级',
  task_detail_assignee_label: '负责人',
  task_detail_creator_label: '创建者',
  task_detail_progress_label: '任务进度',
  task_detail_schedule_label: '日程安排',
  task_detail_additional_info_label: '附加信息',
  task_detail_task_lists_label: '所属清单',
  task_detail_task_lists_empty: '尚未加入任何清单',
  common_edit: '编辑',
  common_save: '保存',
  common_cancel: '取消',
  common_create: '创建',
  task_detail_tags_label: '任务标签',
  task_detail_tags_empty: '尚未添加标签',
  task_detail_tags_updated: '标签更新成功',
  task_detail_tags_update_failed: '更新标签失败，请重试',
  task_detail_watchers_label: '关注人',
  task_detail_attachments_label: '附件',
  task_detail_unassigned: '暂未指派',
  task_detail_unassigned_description: '为任务指定一名负责人',
  task_detail_search_members_placeholder: '搜索成员或输入邮箱',
  common_loading: '加载中...',
  common_select_placeholder: '请选择',
  common_not_set: '未设置',
  task_detail_subtasks_label: '子任务',
  task_detail_subtasks_count_suffix: '个',
  task_detail_add_watcher: '添加关注人',
  task_detail_start_edit_title_tooltip: '点击编辑标题',
  task_detail_start_edit_content_tooltip: '点击编辑内容',
  task_detail_created_at: '创建时间',
  task_detail_updated_at: '更新时间',
  task_detail_overdue_tag: '已逾期',
  task_detail_watch_added: '已添加关注关系',
  task_detail_watch_removed: '已移除关注关系',
  task_detail_select_task_lists_placeholder: '选择所属清单',
  task_detail_select_tags_placeholder: '选择标签',
  task_detail_tag_navigation_hint: '使用 ↑ ↓ 切换，Enter 选择',
  task_detail_list_navigation_hint: '使用 ↑ ↓ 浏览清单',
  task_detail_watchers_count_suffix: '位关注人',
  task_detail_attachments_count_suffix: '个附件',
  task_detail_attachment_size_unit: 'KB',
  task_detail_no_matching_members: '未找到匹配成员',
  task_detail_status_updated: '状态更新成功',
  task_detail_priority_updated: '优先级更新成功',
  task_detail_watch_status_updated: '关注状态更新成功',
  task_detail_task_lists_updated: '任务清单更新成功',
  task_detail_task_lists_update_failed: '任务清单更新失败，请重试',
  task_detail_progress_update_failed: '进度更新失败，请重试',
  task_list_quick_add_placeholder: '快速添加任务（回车创建）',
  task_create_success: '任务创建成功',
  task_list_pagination_total: '第 {start}-{end} 条，共 {total} 条',
  task_list_select_task_hint: '选择一个任务查看详情',
  task_group_view_list: '列表',
  task_group_view_card: '卡片',
  task_group_view_relation: '关系',
  task_group_none: '无分组',
  task_group_task_list: '清单分组',
  task_group_tag: '标签分组',
  task_group_status: '状态分组',
  task_group_priority: '优先级分组',
  task_group_time: '时间分组',
  task_group_repeat: '重复任务',
  task_group_show_empty: '显示空分组',
  task_group_show_completed: '显示已完成任务',
  task_group_show_overdue: '显示已过期任务',
  task_group_show_title: '显示分组标题',
  task_group_display: '分组显示',
  task_group_move_up: '上移',
  task_group_move_down: '下移',
  task_group_title: '标题',
  task_group_default_expanded: '默认展开',
  task_group_show_config: '显示配置',
  task_detail_start_time_set_yesterday: '开始时间已设为昨天',
  task_detail_start_time_set_today: '开始时间已设为今天',
  task_detail_start_time_set_tomorrow: '开始时间已设为明天',
  task_detail_start_time_set_day_after_tomorrow: '开始时间已设为后天',
  task_detail_start_time_set_next_monday: '开始时间已设为下周一',
  task_detail_start_time_set_seven_days_later: '开始时间已设为七天后',
  task_detail_due_date_set_today: '截止日期已设为今天',
  task_detail_due_date_set_tomorrow: '截止日期已设为明天',
  task_detail_due_date_set_day_after_tomorrow: '截止日期已设为后天',
  task_detail_due_date_set_next_monday: '截止日期已设为下周一',
  task_detail_due_date_set_seven_days_later: '截止日期已设为七天后',
  task_detail_load_tags_failed: '加载标签失败，请重试',
  task_detail_default_list_tag: '默认',
  task_detail_public_list_tag: '公开',
  task_detail_unknown_user: '未知用户',
  task_detail_markdown_edit_tab: '编辑',
  task_detail_markdown_preview_tab: '预览',
  task_detail_markdown_insert_image: '插入图片 Markdown',
  task_detail_markdown_preview_empty: '暂无可预览内容',
  task_detail_upload_attachment: '上传文件',
  task_detail_upload_success: '附件上传成功',
  task_detail_upload_failed: '上传失败',
  task_detail_upload_config_missing: '上传配置不完整',
  task_detail_upload_mime_not_allowed: '文件类型不被允许',
  task_detail_upload_file_too_large: '文件超过大小限制',
  task_detail_attachment_download: '下载',
  task_detail_attachment_download_failed: '下载附件失败',
  task_detail_attachment_delete_confirm: '确认删除该附件？',
  task_detail_attachment_delete_success: '附件删除成功',
  task_detail_attachment_delete_failed: '附件删除失败',
  // Task item translations
  task_item_completed: '任务已完成',
  task_item_reactivated: '任务已重新激活',
  task_item_delete_success: '任务已删除',
  task_item_delete_failed: '删除任务失败',
  task_item_update_status_failed: '更新任务状态失败',
  task_item_title_empty: '标题不能为空',
  task_item_title_update_success: '标题更新成功',
  task_item_title_update_failed: '更新标题失败，请重试',
  task_item_delete_button: '删除任务',
  task_item_no_tasks: '暂无任务',
  task_item_priority_none: '无',
  task_item_priority_low: '低',
  task_item_priority_medium: '中',
  task_item_priority_high: '高',
  task_item_priority_urgent: '紧急',
  task_item_days_after: '天后',
  task_item_due_short: '截止',
  task_item_start_short: '开始',
  task_item_no_due: '无截止',
  // Task config translations
  task_config_assign_title: '我负责的任务',
  task_config_today_title: '我今日任务',
  task_config_week_title: '我本周任务',
  task_config_next7days_title: '我未来7天任务',
  task_config_to_assign_title: '我指派的任务',
  task_config_completed_title: '我已完成的任务',
  task_config_all_title: '我的任务',
  task_config_create_title: '我创建的任务',
  task_config_board_title: '看板任务',
  task_config_member_title: '成员任务',
  task_config_task_list_title: '清单任务',
  task_config_tag_title: '标签任务',
  // Task create button translations
  task_create_button_new_task: '新建任务',
  ai_decompose_mode: 'AI 拆解',
  task_create_button_create_new_task: '创建新任务',
  task_create_button_basic_info: '基本信息',
  task_create_button_task_properties: '任务属性',
  task_create_button_task_title: '任务标题',
  task_create_button_priority: '优先级',
  task_create_button_status: '状态',
  task_create_button_assignee: '负责人',
  task_create_button_start_date: '开始日期',
  task_create_button_due_date: '截止日期',
  task_create_button_task_description: '任务描述',
  task_create_button_task_lists: '任务清单',
  task_create_button_task_tags: '任务标签',
  task_create_button_create: '创建',
  task_create_button_cancel: '取消',
  task_create_button_low_priority: '低优先级',
  task_create_button_medium_priority: '中优先级',
  task_create_button_high_priority: '高优先级',
  task_create_button_urgent_priority: '紧急',
  task_create_button_todo: '待办',
  task_create_button_in_progress: '进行中',
  task_create_button_please_enter_title: '请输入任务标题',
  task_create_button_title_max_length: '任务标题不能超过100个字符',
  task_create_button_title_placeholder: '请输入任务标题',
  task_create_button_assignee_placeholder: '请选择负责人',
  task_create_button_start_date_placeholder: '请选择开始日期',
  task_create_button_due_date_placeholder: '请选择截止日期',
  task_create_button_description_placeholder: '请输入任务描述（可选）',
  task_create_button_task_list_placeholder: '请选择任务清单',
  task_create_button_task_list_label: '选择任务清单（可选）',
  task_create_button_select_tags_hint: '为任务选择标签',
  task_create_button_selected_tags: '已选择：',
  task_create_button_new_tag: '新建',
  task_create_button_no_tags: '暂无标签',
  task_create_button_loading: '加载中...',
  task_create_button_no_task_lists: '暂无任务清单',
  task_create_button_create_success: '任务创建成功',
  task_create_button_create_failed: '创建任务失败，请重试',
  // Task template translations
  task_template_fix_bug: '修复 Bug：',
  task_template_requirement_discussion: '需求讨论：',
  task_template_code_review: '代码评审：',
  task_template_optimize_performance: '优化性能：',
  task_template_phenomenon: '现象',
  task_template_phenomenon_text: '现象：\n- ',
  task_template_expectation: '期望',
  task_template_expectation_text: '期望：\n- ',
  task_template_reproduction_steps: '复现步骤',
  task_template_reproduction_steps_text: '复现步骤：\n1. \n2. \n3. ',
  task_template_solution: '解决方案',
  task_template_solution_text:
    '解决方案：\n- 思路：\n- 影响面：\n- 风险与回滚：',
  // Tag modal translations
  tag_modal_create_tag: '创建标签',
  tag_modal_edit_tag: '编辑标签',
  tag_modal_basic_info: '基本信息',
  tag_modal_tag_icon: '标签图标',
  tag_modal_tag_color: '标签颜色',
  tag_modal_tag_name: '标签名称',
  tag_modal_tag_description: '标签描述',
  tag_modal_name_required: '请输入标签名称',
  tag_modal_name_max_length: '标签路径不能超过100个字符',
  tag_modal_description_max_length: '标签描述不能超过100个字符',
  tag_modal_name_placeholder: '请输入标签名称',
  tag_modal_description_placeholder: '请输入标签描述（可选）',
  tag_modal_create_success: '标签创建成功',
  tag_modal_update_success: '标签更新成功',
  tag_modal_create_failed: '创建标签失败',
  tag_modal_update_failed: '更新标签失败',
  tag_modal_cancel: '取消',
  tag_modal_update_tag: '更新标签',
  tag_modal_id_missing: '标签 ID 不存在',
  tag_modal_public_tag: '公开标签',
  tag_modal_shared_members_help:
    '私有标签可共享给成员，被共享成员可查看并编辑标签关联任务',
  tag_modal_shared_members_placeholder: '选择共享成员（可选）',
  resource_shared_members: '共享成员',
  // Board translations
  board_title: '任务大屏',
  board_description: '管理和组织您的任务大屏，提升团队协作效率',
  board_create: '创建大屏',
  board_create_first: '创建第一个大屏',
  board_name: '大屏名称',
  board_description_label: '大屏描述',
  board_name_placeholder: '请输入大屏名称',
  board_description_placeholder: '请输入大屏描述（可选）',
  board_name_required: '请输入大屏名称',
  board_create_success: '大屏创建成功',
  board_create_failed: '创建大屏失败',
  board_update_success: '大屏更新成功',
  board_update_failed: '更新大屏失败',
  board_delete_success: '大屏删除成功',
  board_delete_failed: '删除大屏失败',
  board_delete_confirm_title: '确认删除',
  board_delete_confirm_content: '确定要删除大屏"{name}"吗？',
  board_copy_success: '大屏已复制',
  board_copy_failed: '复制大屏失败',
  board_copy_suffix: ' - 副本',
  board_table_name: '大屏名称',
  board_table_description: '描述',
  board_table_task_count: '任务数量',
  board_table_is_public: '是否公开',
  board_table_public: '公开',
  board_table_private: '私有',
  board_members_label: '邀请企业成员',
  board_members_help: '可为私有大屏成员设置查看者、编辑者或管理员角色',
  board_members_placeholder: '选择企业成员',
  board_members_empty: '暂未邀请成员',
  board_role_viewer: '查看者',
  board_role_editor: '编辑者',
  board_role_admin: '管理员',
  board_public_clears_members: '切换为公开大屏后，将清空全部受邀成员。',
  board_table_created_at: '创建时间',
  board_table_updated_at: '更新时间',
  board_table_actions: '操作',
  board_table_view: '查看',
  board_table_edit: '编辑',
  board_table_copy: '复制',
  board_table_delete: '删除',
  board_table_default: '默认',
  board_table_empty: '暂无大屏，开始创建您的第一个大屏吧',
  board_table_pagination_total: '共 {total} 个大屏',
  board_edit_title: '编辑大屏',
  board_load_failed: '加载数据失败',
  board_panel_personal: '个人看板',
  board_panel_personal_desc: '查看分配给自己的所有任务',
  board_panel_member: '成员看板',
  board_panel_member_desc: '查看特定成员的任务',
  board_panel_list: '清单看板',
  board_panel_list_desc: '按任务清单组织和查看任务',
  board_panel_tag: '标签看板',
  board_panel_tag_desc: '按标签分类查看任务',
  board_panel_create_success: '看板创建成功',
  board_panel_create_failed: '创建看板失败',
  board_panel_delete_success: '面板删除成功',
  board_panel_delete_failed: '删除面板失败',
  board_panel_update_success: '面板更新成功',
  board_panel_update_failed: '更新面板失败',
  board_panel_delete_confirm_content: '确定要删除面板"{title}"吗？',
  board_manage_title: '看板管理',
  board_manage_drag_hint: '拖动可对看板排序',
  board_manage_move_top: '置顶',
  board_manage_move_up: '上移',
  board_manage_move_down: '下移',
  board_manage_move_bottom: '置底',
  board_manage_delete_tooltip: '移除看板',
  board_manage_delete_confirm_title: '移除看板',
  board_manage_delete_confirm_content: '确认将看板"{title}"从大屏中移除吗？',
  board_manage_delete_also_list: '同时删除关联的任务清单',
  board_manage_delete_also_list_warning:
    '任务清单及其下所有任务将被永久删除，无法恢复。',
  board_manage_empty: '暂无看板可管理',
  board_manage_save_order_failed: '保存看板排序失败',
  board_panel_select_member: '选择成员',
  board_panel_select_list: '选择任务清单',
  board_panel_select_tag: '选择标签',
  board_panel_member_label: '成员',
  board_panel_list_label: '任务清单',
  board_panel_tag_label: '标签',
  board_panel_unfinished_tasks: '未完成',
  board_panel_completed_tasks: '已完成',
  board_detail_title: '看板详情',
  board_detail_description: '管理和组织您的任务面板',
  board_detail_not_found: '看板不存在',
  board_detail_name_required: '请输入看板名称',
  board_detail_type_required: '请选择看板类型',
  board_detail_name_placeholder: '请输入看板名称',
  board_detail_description_placeholder: '请输入看板描述（可选）',
  board_detail_load_failed: '加载数据失败',
  board_detail_panel_name_label: '看板名称',
  board_detail_panel_description_label: '看板描述',
  board_detail_panel_type_label: '看板类型',
  board_detail_select_panel_type: '选择看板类型',
  board_detail_create_panel: '创建看板',
  board_detail_panel_total: '{count} 个看板',
  board_detail_create_first_panel: '创建第一个看板',
  board_detail_edit_panel: '编辑看板',
  board_detail_no_panels: '暂无看板，开始创建您的第一个看板吧',
  board_detail_public_badge: '公开',
  board_detail_unknown_member: '未知成员',
  board_detail_unknown_list: '未知清单',
  board_detail_unknown_tag: '未知标签',
  board_detail_self: '自己',
  board_detail_all_tasks: '全部任务',
  board_detail_completed: '已完成',
  board_detail_in_progress: '进行中',
  board_detail_expected_tasks: '预期任务',
  board_detail_recent_tasks: '最近任务',
  board_detail_edit: '编辑',
  board_detail_copy: '复制',
  board_detail_delete: '删除',
  board_detail_delete_confirm_title: '确认删除',
  // Task list translations
  task_list_delete_confirm_title: '确认删除',
  task_list_delete_confirm_content:
    '确定要删除清单 "{name}" 吗？此操作不可恢复。',
  task_list_field_name: '清单名称',
  task_list_field_type: '类型',
  task_list_type_static: '静态',
  task_list_type_dynamic: '动态',
  task_list_field_status: '状态',
  task_list_default: '默认',
  task_list_public: '公开',
  task_list_private: '私有',
  task_list_field_creator: '创建人',
  task_list_field_created_at: '创建时间',
  task_list_share: '分享',
  task_list_rename: '重命名',
  task_list_archive: '归档',
  task_task_lists: '任务清单',
  task_task_lists_description: '管理任务清单，组织和管理不同类型的任务集合',
  task_list_create_new: '新建清单',
  task_list_no_task_lists: '暂无任务清单',
  task_list_edit: '编辑任务清单',
  task_list_name: '清单名称',
  task_list_name_required: '请输入清单名称',
  task_list_name_placeholder: '请输入清单名称',
  task_list_description: '清单描述',
  task_list_description_placeholder: '请输入清单描述',
  task_list_type: '清单类型',
  task_list_type_placeholder: '选择类型',
  task_list_icon: '图标',
  task_list_color: '颜色',
  task_list_is_default: '默认清单',
  task_list_is_public: '公开清单',
  task_list_is_archived: '归档清单',
  task_list_sort_weight: '排序权重',
  task_list_advanced_settings: '高级设置',
  task_list_shared_members_help: '私有清单可共享给成员',
  task_list_shared_members_placeholder: '选择共享成员（可选）',
  task_list_create_success: '清单创建成功',
  task_list_create_error: '创建清单失败，请重试',
  task_list_share_success: '分享设置已保存',
  task_list_share_error: '保存分享设置失败',
  task_list_share_title: '分享清单',
  task_list_share_description: '选择要分享此清单的成员',
  task_list_share_tip: '点击已选成员标签的 X 按钮取消分享',
  task_list_allow_view: '允许查看',
  task_list_allow_edit: '允许编辑',
  task_list_allow_delete: '允许删除',
  task_list_notify_members: '通知成员',
  task_list_select_members: '选择成员',
  task_list_search_members: '搜索成员...',
  task_list_selected_members: '已选择成员',
  task_list_no_members: '暂无可分享成员',
  task_list_no_members_found: '未找到成员',
  // Activity translations
  task_activities_load_failed: '获取任务动态失败',
  task_activity_created: '创建',
  task_activity_updated: '更新',
  task_activity_completed: '完成',
  task_activity_assigned: '分配',
  task_activity_commented: '评论',
  task_activity_status_changed: '状态变更',
  task_activity_priority_changed: '优先级变更',
  task_activity_watched: '关注',
  task_activity_unwatched: '取消关注',
  task_activity_merged: '合并',
  task_activities: '任务动态',
  task_activities_description: '查看任务的最新活动动态',
  task_filter_by_activity_type: '按活动类型筛选',
  task_activities_count: '条动态',
  task_no_activities: '暂无任务动态',
  task_view_task: '查看详情',
  task_task_detail: '任务详情',
  // Common translations
  common_just_now: '刚刚',
  common_minutes_ago: '分钟前',
  common_hours_ago: '小时前',
  common_days_ago: '天前',
  common_weeks_ago: '周前',
  common_total: '共',
  common_unknown: '未知',
  common_actions: '操作',
  common_view: '查看',
  common_delete: '删除',
  common_refresh: '刷新',
  common_update: '更新',
  common_pagination_total: '第 {start}-{end} 条，共 {total} 条',
  // Other task translations
  task_completed: '已完成的',
  task_completed_description: '查看您已完成的所有任务，跟踪完成历史和成就',
  task_assigned_out: '我指派的任务',
  task_assigned_out_description: '查看和管理我指派给其他人的任务',
  task_my_created: '我创建的',
  task_my_created_description: '管理您创建的所有任务，跟踪进度和完成情况',
  task_my_watched: '我关注的',
  task_my_watched_description: '查看和管理我关注的任务，及时跟进关键进展',
  task_filter: '筛选',
  task_sort: '排序',
  // Menu translations
  menu_dashboard: '仪表盘',
  menu_assigned_to_me: '我负责的',
  menu_today: '今天',
  menu_week: '本周',
  menu_next_7_days: '未来七天',
  menu_management: '管理',
  menu_all_tasks: '全部任务',
  menu_my_created: '我创建的',
  menu_my_assigned: '我指派的',
  menu_my_watched: '我关注的',
  menu_completed: '已完成的',
  menu_recycle_bin: '回收站',
  menu_search: '搜索',
  menu_activities: '活动',
  menu_report: '任务日报',
  menu_screen: '大屏',
  menu_all_screens: '所有大屏',
  menu_visible_screens: '可见大屏',
  menu_public_screens: '公开大屏',
  menu_private_screens: '私有大屏',
  menu_task_lists: '清单',
  menu_all_task_lists: '所有清单',
  menu_visible_task_lists: '可见清单',
  menu_tags: '标签',
  menu_all_tags: '所有标签',
  menu_visible_tags: '可见标签',
  // Tag translations
  task_tags: '标签',
  task_tags_description: '管理所有任务标签和分类',
  task_start_date: '开始日期',
  task_end_date: '结束日期',
  // Report translations
  report_task_category_design: '产品设计',
  report_task_category_development: '开发实现',
  report_task_category_testing: '测试验证',
  report_task_category_meeting: '会议沟通',
  report_today_title: '今日日报',
  report_yesterday_title: '昨日日报',
  report_day_before_yesterday_title: '前日日报',
  report_save_success: '日报保存成功',
  report_save_to_local: '日报已保存到本地',
  report_create_success: '日报创建成功',
  report_create_to_local: '日报已创建并保存到本地',
  report_select_date_placeholder: '请选择日期',
  report_today_work_placeholder: '请输入今日完成的工作...',
  report_problems_placeholder: '请输入遇到的问题...',
  report_tomorrow_plan_placeholder: '请输入明日计划...',
  report_daily_summary_placeholder: '请输入当日工作总结...',
  report_solution_placeholder: '请输入解决思路或方案...',
  report_reflection_placeholder: '请输入工作反思...',
  report_progress_placeholder: '请输入具体进展...',
  // Task list detail translations
  task_list_detail_load_failed: '加载任务清单详情失败',
  task_list_detail_update_success: '任务清单更新成功',
  task_list_detail_update_failed: '更新任务清单失败',
  task_list_detail_delete_success: '任务清单删除成功',
  task_list_detail_delete_failed: '删除任务清单失败',
  task_list_detail_get_task_failed: '获取任务失败',
  task_list_detail_task_already_in_list: '该任务已在当前清单中',
  task_list_detail_task_added_success: '任务已添加到清单',
  task_list_detail_add_task_failed: '添加任务到清单失败',
  task_list_detail_edit_list: '编辑清单',
  task_list_detail_refresh_data: '刷新数据',
  task_list_detail_delete_list: '删除清单',
  task_list_detail_no_description: '暂无描述',
  task_list_detail_static_list: '静态清单',
  task_list_detail_dynamic_list: '动态清单',
  task_list_detail_sort: '排序',
  task_list_detail_more_options: '更多选项',
  task_list_detail_search_task_placeholder: '搜索并选择任务添加到清单',
  task_list_detail_no_matching_tasks: '未找到匹配的任务',
  task_list_detail_no_available_tasks: '暂无可用任务',
  task_list_detail_unnamed_task: '未命名任务',
} as const;

const ja = { ...en };
const de = { ...en };
const es = { ...en };
const fr = { ...en };
const ptBR = { ...en };
const ru = { ...en };
const ko = { ...en };
const it = { ...en };
const zhTW = { ...zhCN };
const pl = { ...en };
const tr = { ...en };
const cs = { ...en };

export const translations: Translations = {
  en,
  'zh-cn': zhCN,
  'zh-tw': zhTW,
  ja,
  de,
  es,
  fr,
  'pt-br': ptBR,
  ru,
  ko,
  it,
  pl,
  tr,
  cs,
};
